import { useRef } from 'react'
import { useWizard } from '@/common/wizard/wizard'
import { useAppContext } from '@/context/app'

const sessionKey = 'report_userranking_wizard'

export interface WizardData {
  from: Date
  to: Date
  acceptedSteps: string[]
  submissionError?: string
  submitting?: boolean
}

export const cleanWizardData = (): WizardData => {
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  const endOfToday = new Date();
  endOfToday.setHours(23, 59, 0, 0);

  const empty: WizardData = {
    from: startOfToday,
    to: endOfToday,
    acceptedSteps: [],
  };

  return empty
}

export const useChecklistSubmit = (machineId: string | undefined) => {
  const { services } = useAppContext()
  const { wizardData, updateWizardData } = useWizard<WizardData>()
  const pending = useRef(false)

  return async (status: 'success' | 'fail', failedStep?: string): Promise<boolean> => {
    if (pending.current || wizardData.submitting) return false
    pending.current = true
    updateWizardData({ submitting: true, submissionError: undefined })
    try {
      if (!machineId) throw new Error('Missing machine ID')
      const response = await services.session.fetchWithToken(`/api/communal/machines/byid/${machineId}/checklist`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status, failedStep, acceptedSteps: wizardData.acceptedSteps }),
      })
      if (!response.ok) {
        updateWizardData({ submissionError: response.status === 403 ? 'errors.checklist_unavailable' : 'errors.general_error' })
        return false
      }
      return true
    } catch {
      updateWizardData({ submissionError: 'errors.general_error' })
      return false
    } finally {
      pending.current = false
      updateWizardData({ submitting: false })
    }
  }
}
